const cstVerifyStrings = {
  linkExpired: {
    header: 'This link has expired.',
    body: '',
  },
  success: {
    title: 'Verification\ncomplete',
    body: 'Please continue with customer support for assistance with your request.',
  },
};

export default cstVerifyStrings;
